<app-dashboard-container
	class="dashboard-cohortdetails"
	[factTable]="factTable"
	[exportTypes]="exportTypes"
	[filterbalkVisible]="!fullScreen()"
	(doExport)="this.doExport(filterExpressions(), permanentFilterExpressions, updateExportOptions($event))"
>
	<app-filter-panel
		[defaultFilters]="getFilterNames()"
		[allFilters]="allFilters()"
		(filterExpressionsChange)="filterExpressions.set($event)"
		endpoint="/doorstroom"
		[permanentFilterExpressions]="permanentFilterExpressions"
	>
	</app-filter-panel>
	<app-filter-bar></app-filter-bar>
	<section class="dashboard">
		@if (!fullScreen()) {
			<app-dashboard-header>
				@if (subtitle) {
					<div class="cl-header-subtitle">{{ subtitle }}</div>
				}
				<app-single-select-dropdown
					label="Type"
					[opties]="typeOpties"
					[selectedOptie]="typeOptie"
					(onOptieClicked)="qp.dispatch('cohortrendementtype', $event)"
				></app-single-select-dropdown>
				<app-weergave-optie label="Eenheid" param="eenheid" [value]="eenheid()" [enum]="Eenheid"></app-weergave-optie>
				<app-button class="cl-header-utility" icon="full-screen" buttonType="text" (clickit)="toggleFullScreen()">Vergroten</app-button>
				<app-legenda class="cl-header-utility" [style]="'PILL'" [attribute]="['ds_fun_nm_doorstroom_ext']" [includeNull]="true"></app-legenda>
			</app-dashboard-header>
		} @else {
			<div class="floating">
				<app-button icon="full-screen-off" buttonType="text" (clickit)="toggleFullScreen()">Verkleinen</app-button>
				<app-legenda [style]="'PILL'" [attribute]="['ds_fun_nm_doorstroom_ext']" [includeNull]="true"></app-legenda>
			</div>
		}
		<app-cohort-graph
			[filters]="filterExpressions()"
			[permanentFilters]="permanentFilterExpressions"
			[richting]="typeOptie.richting"
			[eenheid]="eenheid()"
		></app-cohort-graph>
	</section>
</app-dashboard-container>
